import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// MUI
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

function Form(props) {
  const { filterControls, classes, onFilterChange } = props;
  const { t } = useTranslation();

  return (
    <Card className={classes.root}>
      <CardHeader title={t('Filter')} />
      <CardContent>
        <Grid container spacing={3} className={classes.container}>
          <Grid container item sm={4} xs={12}>
            <TextField
              fullWidth
              id="name"
              label={t('Name')}
              value={filterControls.name}
              onChange={onFilterChange}
            />
          </Grid>
          <Grid container item sm={4} xs={12}>
            <TextField
              fullWidth
              id="code"
              label={t('Code')}
              value={filterControls.code}
              onChange={onFilterChange}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default Form;
